import { render } from "./PhotosSectionView.vue?vue&type=template&id=28002a72&scoped=true"
import script from "./PhotosSectionView.vue?vue&type=script&lang=js"
export * from "./PhotosSectionView.vue?vue&type=script&lang=js"

import "./PhotosSectionView.vue?vue&type=style&index=0&id=28002a72&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28002a72"]])

export default __exports__